export const userRole = {
  InternalSalesman: 'VIN',
  Representative: 'REP',
  Supervisor: 'SUP',
  Manager: 'GER',
  Administrator: 'ADM',
  StockManager: 'RES'
}

const {
  InternalSalesman,
  Representative,
  Supervisor,
  Manager,
  Administrator,
  StockManager
} = userRole

export const USER_ROLES_OPTION = [
  { id: InternalSalesman, name: 'VENDEDOR', level: 1 },
  { id: Representative, name: 'REPRESENTANTE', level: 1 },
  { id: Supervisor, name: 'RESPONSAVEL REPRESENTANTE', level: 2 },
  { id: Manager, name: 'GERENTE', level: 3 },
  { id: Administrator, name: 'ADMINISTRADOR', level: 4 },
  // Responsável Estoque: fora da hierarquia de alçada de desconto (level 1),
  // seu acesso a reserva é controlado pelo backend, não pelo level.
  { id: StockManager, name: 'RESPONSAVEL ESTOQUE', level: 1 }
]
